import logger from "@next/core-logger"
import Cookies from "js-cookie"
import {
    PERSONALISATION_SESSION_STORAGE_KEY,
    UCM_ONSITE_CONSENT,
    PERSONALISATION_ERROR_RESPONSE,
    PERSONALISATION_LOADING,
} from "../../config/constants"
import {getRpId} from "../getRpId"
import {getPersonalisationData} from "../../api/personalizationRetrievalService"
import {PublishPersonalisationDataRetrieved} from "../../events/personalisationDataRetrieved"

export const setPersonalisationData = (prsKeyWithRpid: string, personalisationData: any) => {
    if (personalisationData !== PERSONALISATION_ERROR_RESPONSE) {
        window.sessionStorage?.setItem(PERSONALISATION_SESSION_STORAGE_KEY, JSON.stringify(personalisationData))
        window.sessionStorage?.setItem(prsKeyWithRpid, Date.now().toString())
        PublishPersonalisationDataRetrieved()
    }
    window.sessionStorage?.removeItem(PERSONALISATION_LOADING)
}

export const getRealTimePersonalisationData = (
    prsEnabled: boolean,
    prsAPIVersion: string,
    realm: string,
    territory: string,
    language: string,
    siteUrl: string,
    isAnonymousUser: boolean,
    isUcmEnabled: boolean,
) => {
    const rpid = getRpId()
    const onsiteConsent = Cookies.get(UCM_ONSITE_CONSENT) || ""
    const prsKeyWithRpid = `${PERSONALISATION_SESSION_STORAGE_KEY}_${rpid}`
    const isPrsLoading = sessionStorage.getItem(PERSONALISATION_LOADING) === true.toString()
    if (!rpid || (onsiteConsent !== true.toString() && isUcmEnabled) || !prsEnabled || isPrsLoading) return

    if (!Object.keys(sessionStorage).includes(prsKeyWithRpid)) {
        window.sessionStorage?.setItem(PERSONALISATION_LOADING, true.toString())
        getPersonalisationData(rpid, realm, territory, language, siteUrl, isAnonymousUser, prsAPIVersion)
            .then(data => {
                setPersonalisationData(prsKeyWithRpid, data)
            })
            .catch(err => {
                window.sessionStorage?.removeItem(PERSONALISATION_LOADING)
                logger.error(err)
            })
    }
}

export const isAnonymous = (firstName: string) => !firstName || firstName.length <= 0
